<template>
  <b-dropdown right :text="summaryText" variant="outline-dark" @hide="saveChanges" ref="dropdown" :disabled="disabled">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-form-group label="Filter events from:">
        <b-form-radio-group v-model="rangeType">
          <b-form-radio value="recent">Recent&nbsp;time&nbsp;span</b-form-radio>
          <b-form-radio value="custom">Custom&nbsp;date&nbsp;range</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group v-if="rangeType === 'recent'">
        <b-input-group prepend="Last">
          <b-form-input v-model="count"></b-form-input>
          <b-form-select v-model="periodType">
            <option :value="null" disabled>Select</option>
            <option value="days">Days</option>
            <option value="weeks">Weeks</option>
            <option value="months">Months</option>
            <option value="years">Years</option>
          </b-form-select>
        </b-input-group>
      </b-form-group>
      <div v-if="rangeType === 'custom'">
        <b-form-group id="start-date-label" label="Start Date" label-for="start-date">
          <date-picker id="start-date" v-model="rangeStart" style="width:100%" lang="en" format="DD/MM/YYYY"></date-picker>
        </b-form-group>
        <b-form-group id="end-date-label" label="End Date" label-for="end-date">
          <date-picker id="end-date" v-model="rangeEnd" style="width:100%" lang="en" format="DD/MM/YYYY"></date-picker>
        </b-form-group>
      </div>
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'DateFilter',
  props: ['filter', 'disabled'],
  components: { DatePicker },
  data () {
    return {
      rangeType: this.filter.range_type,
      count: this.filter.count,
      periodType: this.filter.period_type,
      rangeStart: (this.filter.range_start ? moment(this.filter.range_start, 'Y-M-D') : moment().subtract(1, 'months')),
      rangeEnd: (this.filter.range_end ? moment(this.filter.range_end, 'Y-M-D') : moment()),
      isValid: true,
      errorMessage: ''
    }
  },
  computed: {
    summaryText () {
      if (this.filter.range_type === 'recent') {
        if (this.filter.count > 1) {
          const periodText = {days: 'days', weeks: 'weeks', months: 'months', years: 'years'}[this.filter.period_type]
          return `Last ${this.filter.count} ${periodText}`
        } else {
          const periodText = {days: 'day', weeks: 'week', months: 'month', years: 'year'}[this.filter.period_type]
          return `Last ${this.filter.count} ${periodText}`
        }
      } else {
        return `${moment(this.filter.range_start, 'Y-M-D').format('L')} - ${moment(this.filter.range_end, 'Y-M-D').format('L')}`
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    validate () {
      this.isValid = true
      if (this.rangeType === 'recent') {
        if (isNaN(parseInt(this.count))) {
          this.isValid = false
          this.errorMessage = 'Please enter a valid number'
        } else if (this.periodType == null) {
          this.isValid = false
          this.errorMessage = 'Please enter a period type'
        }
      }
      if (this.rangeType === 'custom') {
        if (this.rangeStart == null) {
          this.isValid = false
          this.errorMessage = 'Please select a start date'
        } else if (this.rangeEnd == null) {
          this.isValid = false
          this.errorMessage = 'Please select an end date'
        } else if (this.rangeStart >= this.rangeEnd) {
          this.isValid = false
          this.errorMessage = 'Start date must be before end date'
        }
      }
      return this.isValid
    },
    resetAndClose (evt) {
      this.rangeType = this.filter.range_type
      this.count = this.filter.count
      this.periodType = this.filter.period_type
      this.rangeStart = (this.filter.range_start ? moment(this.filter.range_start, 'Y-M-D') : moment().subtract(1, 'months'))
      this.rangeEnd = (this.filter.range_end ? moment(this.filter.range_end, 'Y-M-D') : moment())
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      this.filter.range_type = this.rangeType
      if (this.rangeType === 'recent') {
        this.filter.count = this.count
        this.filter.period_type = this.periodType
        delete this.filter.range_start
        delete this.filter.range_end
      } else {
        delete this.filter.count
        delete this.filter.period_type
        this.filter.range_start = moment(this.rangeStart).format('Y-M-D')
        this.filter.range_end = moment(this.rangeEnd).format('Y-M-D')
      }
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/DateFilter.vue